import { http, HttpResponse } from 'msw';
import {
  successfulTokenResponse,
  unsuccessfulTokenResponse,
  validUser,
} from './mocks';

export const handlers = [
  http.post(`${import.meta.env.VITE_URL}/api/v1/login`, async ({ request }) => {
    const data = (await request.json()) as {
      username: string;
      password: string;
    };

    if (
      data.username == validUser.username &&
      data.password === validUser.password
    ) {
      return HttpResponse.json(successfulTokenResponse);
    } else {
      return HttpResponse.json(unsuccessfulTokenResponse, { status: 422 });
    }
  }),

  http.delete(
    `${import.meta.env.VITE_URL}/api/v1/logout`,
    async ({ request }) => {
      if (request.headers.get('authorization')?.includes('Bearer ')) {
        return HttpResponse.json(successfulTokenResponse);
      } else {
        return HttpResponse.json(unsuccessfulTokenResponse, { status: 401 });
      }
    },
  ),

  http.post(
    `${import.meta.env.VITE_URL}/api/v1/register`,
    async ({ request }) => {
      return HttpResponse.json(201);
    },
  ),
];
